<template slot:header>
  <!--Menu for mobile devices-->
  <div id="menu--bar">
    <img
      v-if="isMobile()"
      @click="goToHome"
      src="../assets/img/assuraf_white.png"
      width="150"
      alt="logo assuraf"
    />

    <v-toolbar
      id="allowMargin"
      color="#FFF"
      fixed
      class="allowMarginStyle elevation-18 extended mb-5"
      style="z-index: 3"
    >
      <v-toolbar-title v-if="isDesktop()" style="padding-left: 8%">
        <img
          @click="reloadPage()"
          src="../assets/img/assuraf_sm.png"
          width="75%"
          alt="logo assuraf"
          style="cursor: pointer"
        />
      </v-toolbar-title>

      <v-toolbar-title v-if="isMobile()" style="width: stretch">
        <span class="justify-content-center row">
          <img
            @click="reloadPage()"
            src="../assets/img/assuraf_sm.png"
            width="30%"
            alt="logo assuraf"
            style="cursor: pointer"
          />
        </span>
      </v-toolbar-title>

      <v-toolbar-title v-if="isMobile() && Mano2 > 0">
        <v-btn icon small flat @click="RedirectionPaiemtnDiffere">
          <v-icon color="red">&#xe906;</v-icon>
        </v-btn>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div class="hidden-sm-and-down policeLato mt-3" style="padding-right: 5%">
        <!-- ================ ICON  ==================-->
        <v-btn
          icon
          small
          flat
          style="margin-right: -10px"
          @click="RedirectionPaiemtnDiffere"
          v-if="Mano2 > 0"
        >
          <v-icon color="red">&#xe906;</v-icon>
        </v-btn>

        <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
      </div>

      <!-- <v-toolbar-side-icon class="menu-button" clipped-right @click="sideNav = true" ></v-toolbar-side-icon> -->

      <div v-if="isMobile()">
        <div class="phone">
          <div class="top-bar"></div>
        </div>
      </div>

      <!-- <v-toolbar-side-icon clipped-right @click.native.stop="sideNav = !sideNav" class="hidden-md-and-up"></v-toolbar-side-icon> -->
    </v-toolbar>

    <div v-show="isDesktopWhatsapp" :style="whatsappFloatStyle">
<!--      <div id="floating_bouton" v-show="allowIconSinitre">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a @click="toSinistre()" title="Déclarer sinistre"
                ><img
                  src="../assets/img/home/new_home/sinistreKiray.png"
                  class="img-fluid mob-what"
                  alt="kirray_sinistre"
                  width="77"
              /></a>
            </div>
          </div>
        </section>
      </div>-->

      <div id="floating_bouton_whatsapp">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a
                href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋"
                target="_blank"
                rel="nofollow noopener noreferrer"
                ><img
                  src="../assets/img/home/new_home/WhatsApp_icon.png"
                  class="mr-2 img-fluid mob-what"
                  alt="whatsapp_icon"
                  width="70"
              /></a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div v-show="isMobileWhatsapp">
<!--      <div id="floating_bouton_mobile" v-show="allowIconSinitre">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a @click="toSinistre()" title="Déclarer sinistre"
                ><img
                  src="../assets/img/home/new_home/sinistreKiray.png"
                  class="img-fluid mob-what"
                  alt="kirray_sinistre"
                  width="75"
              /></a>
            </div>
          </div>
        </section>
      </div>-->

      <div id="floating_bouton_whatsapp_mobile">
        <section>
          <div class="eazy-audio-wrapper">
            <div>
              <a
                href="whatsapp://send?phone=+221761416464&text=Hello Assuraf 👋"
                target="_blank"
                rel="nofollow noopener noreferrer"
                ><img
                  src="../assets/img/home/new_home/WhatsApp_icon.png"
                  class="img-fluid mob-what"
                  alt="whatsapp_icon"
                  width="70"
              /></a>
            </div>
          </div>
        </section>
      </div>
    </div>

    <login-form :visible="showLoginForm" @close="showLoginForm = false"></login-form>
  </div>
</template>

<script>
import AuthService from './../services/AuthenticationService';
import Api from './../services/Api';
import { mapGetters } from 'vuex';
//import AnchorRouterLink from 'vue-anchor-router-link'
import store from '../store/store';
import PushInDataLayer from '../services/TagManager';
import LoginForm from './auth/Login';
import $ from 'jquery';

const images = require.context('@/assets/img/icones/menu/', false, /\.png$|\.jpg$/);

export default {
  name: 'Menu',
  components: {
    LoginForm
    //AnchorRouterLink,
  },
  data: function () {
    return {
      showEntityHealth: false,
      showEntityInsurances: false,
      isMobileWhatsapp: false,
      isDesktopWhatsapp: false,
      allowbuttondownload: true,
      allowIconSinitre: true,
      partnerCode: process.env.VUE_APP_CODEP, //process.env.VUE_APP_CODEP,//"LOK839",//
      hideMenu: true,
      langs: ['FR', 'EN'],
      fav: true,
      menu: false,
      hints: true,
      loggedUser: '',
      Mano: null,
      Mano2: 0,
      demo: 0,
      showLoginForm: false,
      sideNav: false,
      drawer: true,
      password_new: null,
      LoginDialog: false,
      verifBranche: null,
      menuItems: [
        {
          title: 'A propos',
          link: '/apropos',
          icon: 'question_answer',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      menuItems1: [
        {
          title: 'Contact',
          link: '/#ContactForm',
          icon: 'call',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      menuItems2: [
        {
          title: 'Contact',
          link: '/ContactForm',
          icon: 'call',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      //Devis menu
      DevisItems: [
        {
          title: 'Auto/Moto',
          link: '/devis/auto',
          icon: 'directions_car',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Habitation',
          link: '/devis/habitation',
          icon: 'home',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Voyage',
          link: '/devis/voyage',
          icon: 'airplanemode_active',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Santé',
          link: '/devis/sante',
          icon: 'local_hospital',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Vie',
          link: '/devis/vie',
          icon: 'favorite',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Assur+',
          link: '/plus',
          icon: 'plus',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      //Simulation menu
      SimulationItems: [
        {
          title: 'Auto/Moto',
          link: '/devis/auto',
          icon: 'directions_car',
          imagePath: '../assets/img/icones/menu/mrp_quote.png',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      DevisItems1: [
        {
          title: 'Devis',
          link: '/devis',
          icon: 'subject',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      //Assurance menu
      AssuranceItems: [
        {
          title: 'Auto/Moto',
          link: '/assurance/Auto-Moto',
          icon: 'directions_car',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Habitation',
          link: '/assurance/Habitation',
          icon: 'home',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Voyage',
          link: '/assurance/Voyage',
          icon: 'airplanemode_active',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Santé',
          link: '/assurance/Sante',
          icon: 'local_hospital',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Vie',
          link: '/assurance/vie',
          icon: 'favorite',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Assur+',
          link: '/assurance/Assurplus',
          icon: 'favorite',
          hasAcount: !this.$store.state.isUserLoggedIn
        },
        {
          title: 'Sinistres',
          link: '/assurance/sinistre',
          icon: 'favorite',
          hasAcount: !this.$store.state.isUserLoggedIn
        }
      ],
      createdAcount: false,
      recoveryPassword: false,
      ServerRep: null,
      step: 0,
      alert: false,
      message: {
        type: null,
        texte: null
      },
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      }, // Customized options for success toast
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'error'
      }, // Customized options for error toast
      userLogin: {
        email: '',
        password: ''
      },
      userRegister: {
        email: '',
        password: '',
        confirmPass: '',
        telephone: '',
        nom: '',
        prenom: ''
      },
      devisIcon: [
        {
          autoImage: '../assets/img/icones/menu/mrp_quote.png'
        },
        {
          autoImage: '../assets/img/icones/menu/mrp_quote.png'
        },
        {
          autoImage: '../assets/img/icones/menu/mrp_quote.png'
        }
      ]
    };
  },

  created() {
    this.fetchEventsList();
    this.timer = setInterval(this.fetchEventsList, 60000);
    this.timer3 = setInterval(this.checkContratAFinaliser, 1000);
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },
    toSinistre() {
      if (!this.$store.state.isUserLoggedIn) {
        this.showLoginForm = true;
      } else {
        this.$router.go(this.$router.push('/sinistre'));
      }
    },
    showEntityHealthFunction() {
      this.showEntityHealth = !this.showEntityHealth;
    },
    showEntityInsurancesFunction() {
      this.showEntityInsurances = !this.showEntityInsurances;
    },
    goToHome() {
      this.$router.push('/');
      this.sideNav = false;
    },
    goToSimAuto() {
      this.$router.push('/simulate/devis/auto');
    },
    checkToken() {
      Api()
        .get('user/check/token')
        .then((resultat) => {
          if (resultat.data.ok === true) {
            console.log('ok');
          } else {
            store.state.isUserLoggedIn = false;
            store.dispatch('setUser', {});
            store.dispatch('setToken', {});
          }
        })
        .catch((err) => {
          if (err.response.data.ok === false) {
            store.state.isUserLoggedIn = false;
            store.dispatch('setUser', {});
            store.dispatch('setToken', {});
          }
        });
    },
    allowWhatsapp() {
      if (screen.width <= 768) {
        this.isMobileWhatsapp = true;
        this.isDesktopWhatsapp = false;
      } else {
        this.isMobileWhatsapp = false;
        this.isDesktopWhatsapp = true;
      }
    },
    selectCountry() {
      Api()
        .post('partenaires/set/selected', { pays: 'Senegal', societe: 'SNSAAS Assuraf Cleo' })
        .then((resultat) => {
          this.$store.dispatch('selectCountry', resultat.data);
          this.$nextTick(() => {});
        })
        .catch((error) => {});
    },

    loadImg(imgPath) {
      return images('./' + imgPath);
    },
    toDevisFlotte() {
      this.closeMenuBurger();
      this.$router.push('/flotte/entreprise/');
    },

    toDevisMrp() {
      this.closeMenuBurger();
      this.$router.push('/devis/mrp/');
    },
    toDevisTrc() {
      this.closeMenuBurger();
      this.$router.push('/devis/trc/');
    },

    toRcScolaire() {
      this.closeMenuBurger();
      this.$router.push('/rcscolaire/');
    },

    allowSinitre() {
      const currentUrl = this.$router.currentRoute.name;
      if (currentUrl == 'sinistre') {
        this.allowIconSinitre = false;
      } else {
        this.allowIconSinitre = true;
      }
    },
    toSinistre() {
      if (!this.$store.state.isUserLoggedIn) {
        this.showLoginForm = true;
      } else {
        this.$router.push('/sinistre');
      }
    },
    updateLanguage() {
      const locale = String(this.$i18n.locale || 'FR')
        .trim()
        .toUpperCase()
        .startsWith('EN')
        ? 'EN'
        : 'FR';
      this.$i18n.locale = locale;
      sessionStorage.setItem('locale', locale);
    },
    closeMenuBurger() {
      const $menu = $('.menu');
      const $button = $('.menu-button');
      $menu.toggleClass('show');
      const hamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:0px;top:-1px">&#9776;</span>';
      const closeHamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:2px;top:-2px">&#10005;</span>';
      $button.text($menu.hasClass('show') ? '' : '');
      if (!$menu.hasClass('show')) {
        $button.html(hamburgerIcon);
      } else {
        $button.html(closeHamburgerIcon);
      }
    },
    link_menu_onclick(branche) {
      this.closeMenuBurger();

      if (branche == 'Auto/Moto') {
        this.$quoteCreationEntryPoint.entry_point = 'menu';
        localStorage.setItem('quoteCreationEntryPoint', 'menu');
        let GtmVal = {
          branche: 'automobile',
          entry_point: 'menu',
          event: 'quote_creation_intent'
        };
        PushInDataLayer(GtmVal);
      } else if (branche == 'Santé') {
        this.$quoteCreationEntryPoint.entry_point = 'menu';
        localStorage.setItem('quoteCreationEntryPoint', 'menu');
        let GtmVal = {
          branche: 'sante',
          entry_point: 'menu',
          event: 'quote_creation_intent'
        };
        PushInDataLayer(GtmVal);
      } else {
        this.$quoteCreationEntryPoint.entry_point = 'menu';
        localStorage.setItem('quoteCreationEntryPoint', 'menu');
        let GtmVal = {
          branche: branche.toLowerCase(),
          entry_point: 'menu',
          event: 'quote_creation_intent'
        };
        PushInDataLayer(GtmVal);
      }
    },

    ContactEntryPoint(entryPoint) {
      this.closeMenuBurger();
      this.$contactUsEntryPoint.entry_point = entryPoint;
      const val = {
        entry_point: entryPoint,
        event: 'contact_intent'
      };
      PushInDataLayer(val);
    },

    LoadPopupMobileLeft() {
      this.$loginPopupPosition.position = 'mobile-top-left';
      this.$loginPopupPosition.event = 'login';

      const val = {
        position: 'mobile-top-left',
        event: 'login'
      };

      PushInDataLayer(val);
      this.showLoginForm = true;
    },

    LoadPopupMobileRight() {
      this.$loginPopupPosition.position = 'mobile-top-right';
      this.$loginPopupPosition.event = 'login';

      const val = {
        position: 'mobile-top-right',
        event: 'login'
      };
      PushInDataLayer(val);
      this.showLoginForm = true;
    },

    LoadLoginPopupDesktop() {
      this.$loginPopupPosition.position = 'desktop';
      this.$loginPopupPosition.event = 'Sign_up';

      const val = {
        position: this.$loginPopupPosition.position,
        event: this.$loginPopupPosition.position
      };
      PushInDataLayer(val);
      this.showLoginForm = true;
    },

    checkContratAFinaliser() {
      if (this.$store.state.user && this.$store.state.devispayementDiffere) {
        if (!this.Mano) {
          this.Mano = 12;
        }
        this.Mano2 = this.Mano2 + 1;
      } else {
        this.Mano2 = 0;
      }
    },

    fetchEventsList() {
      if (this.Mano > 0) {
        this.Mano = this.Mano - 1;
      }

      if (this.Mano == 0 && this.$store.state.devispayementDiffere) {
        this.$store.dispatch('setDevisPayementDiffere', null);
      }
    },

    RedirectionEspaceAssure() {
      this.closeMenuBurger();
      if (this.$store.state.isUserLoggedIn) {
        this.$router.push('/dashboard');
      } else {
        this.LoadPopupMobileRight();
        //this.showLoginForm = true
      }
    },

    RedirectionPaiemtnDiffere() {
      if (this.verifBranche == 'Autre') {
        this.$router.push('/paiement/differe');
      } else if (this.verifBranche == 'Santé') {
        this.$router.push('/payement/nest/differe');
      }
    },

    isMobile: function () {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },

    isDesktop: function () {
      if (screen.width > 768) {
        return true;
      } else {
        return false;
      }
    },
    isTablette() {
      if (screen.width > 425 && screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },

    async login() {
      const loginResp = await AuthService.login({
        email: this.userLogin.email,
        password: this.userLogin.password
      });

      if (loginResp.data.error) {
        this.alert = true;
        this.message.type = 'error';
        this.message.texte = loginResp.data.error;
        this.userLogin.password = '';
      } else {
        await this.$store.dispatch('setToken', loginResp.data.token);
        await this.$store.dispatch('setUser', loginResp.data);
        this.userLogin = {};
        this.LoginDialog = false;

        const UserForInercom = {
          name: loginResp.data.nom + ' ' + loginResp.data.prenom,
          email: loginResp.data.email,
          Phone: loginResp.data.telephone_port
        };

        localStorage.setItem('InercomName', UserForInercom.name);
        localStorage.setItem('InercomEmail', UserForInercom.email);
        localStorage.setItem('InercomPhone', UserForInercom.Phone);

        if (
          this.$route.path != '/devis/sonac/caution' &&
          this.$route.path != '/individuel' &&
          this.$route.path != '/devis/voyage' &&
          this.$route.path != '/devis/auto' &&
          this.$route.path != '/devis/habitation' &&
          this.$route.path != '/sante/nest' &&
          this.$route.path != '/sante/nest/' &&
          this.$route.path != '/sante/transvie/Entreprise' &&
          this.$route.path != '/sante/transvie/individuel' &&
          this.$route.path != '/sante/kermel/famille' &&
          this.$route.path != '/simulate/devis/auto' &&
          this.$route.path != '/simulate/devis/liste' &&
          this.$route.path != '/sante/kermel/suivi'
        ) {
          window.location.reload();
        }
      }
    },

    /*===LOGIN USER WITH COOKIES INFORMATIONS===*/
    login_With_Cookies() {
      const login = document.cookie.match(new RegExp('(^| )ULI=([^;]+)'));
      if (typeof login == 'object' && login != null) {
        this.userLogin.email = decodeURIComponent(login[2]);
      }
    },

    async register() {
      const response = await AuthService.signup({
        email: this.userRegister.email,
        password: this.userRegister.password,
        confirmPass: this.userRegister.confirmPass,
        telephone_port: this.userRegister.telephone,
        nom: this.userRegister.nom,
        prenom: this.userRegister.prenom,
        role: 'User',
        etat: 'Online'
      });
      if (response.statusText === 'OK') {
        const resp = await AuthService.login({
          email: this.userRegister.email,
          password: this.userRegister.password
        });

        await this.$store.dispatch('setToken', resp.data.token);
        await this.$store.dispatch('setUser', resp.data); // on avait : resp.data.user 'user' n'existait pas; tout le contenu se trouve dans data

        const UserForInercom = {
          name: this.userRegister.nom + ' ' + this.userRegister.prenom,
          email: this.userRegister.email,
          Phone: this.userRegister.telephone
        };

        this.alert = true;
        this.message.texte = 'User created'; // response.data.message
        this.message.type = 'success'; // ça n'existait pas je l'ai fixé pour le moment
        this.userRegister = {};
        this.LoginDialog = false;

        localStorage.setItem('InercomName', UserForInercom.name);
        localStorage.setItem('InercomEmail', UserForInercom.email);
        localStorage.setItem('InercomPhone', UserForInercom.Phone);

        if (
          this.$route.path != '/devis/sonac/caution' &&
          this.$route.path != '/individuel' &&
          this.$route.path != '/devis/voyage' &&
          this.$route.path != '/devis/auto' &&
          this.$route.path != '/devis/habitation' &&
          this.$route.path != '/sante/nest' &&
          this.$route.path != '/sante/nest/' &&
          this.$route.path != '/sante/transvie/Entreprise' &&
          this.$route.path != '/sante/transvie/individuel' &&
          this.$route.path != '/sante/kermel/famille' &&
          this.$route.path != '/simulate/devis/auto' &&
          this.$route.path != '/simulate/devis/liste' &&
          this.$route.path != '/sante/kermel/suivi'
        ) {
          window.location.reload();
        }
      }
    },

    userUpdatePassword: function () {
      if (this.password_new) {
        const params = {
          email: this.password_new
        };
        Api()
          .post('user/resetpassword', params)
          .then((response) => {
            this.ServerRep = response.status;
          });
      } else {
        this.$toasted.show('Votre adresse email est obligatoire ', this.ToastTabError);
      }
    },

    scrollMeTo(refName) {
      const element = this.$refs[refName];
      const top = element.offsetTop;
      window.scrollTo(0, top);
    },

    toDashboard() {
      this.$router.push('/dashboard');
    },

    ContactForm() {
      let routetoContact = !this.$router.currentRoute;
      if (routetoContact) {
      }
    },

    StorageRemover() {
      this.$store.dispatch('setToken', null);
      this.$store.dispatch('setUser', null);
      this.$store.dispatch('setDevis', null);
      this.$store.dispatch('setDevisPayement', null);
      this.$store.dispatch('setDevisPayementDiffere', null);
      this.$store.dispatch('setuser_quote_count', null);
      this.$store.dispatch('setuser_contract_count', null);

      localStorage.removeItem('canal');
      localStorage.removeItem('numdevis');
      localStorage.removeItem('amount');
      localStorage.removeItem('adressliv');
      localStorage.removeItem('Callback');
      localStorage.removeItem('passenger-birthady-age');
      localStorage.removeItem('loic');
      localStorage.removeItem('papa');
      localStorage.removeItem('UserArray');
      localStorage.removeItem('PaymentlinkId');
      localStorage.removeItem('InercomName');
      localStorage.removeItem('InercomEmail');
      localStorage.removeItem('InercomPhone');
      localStorage.removeItem('seturlapi');
      localStorage.removeItem('item_list_name');
      localStorage.removeItem('EcommercePushed');
      localStorage.setItem('isLogged', false);
      localStorage.removeItem('vuex');
    },

    logout() {
      Api()
        .get('user/logout/' + store.state.user._id)
        .then((resp) => {
          if (resp) {
            this.StorageRemover();
          } else {
            this.StorageRemover();
          }
        })
        .catch((err) => {
          this.StorageRemover();
        });

      //if(this.$route.path!="/"){
      this.$router.push('/');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      //}
    },

    gotoprofile() {
      this.$router.push('/profil');
    }
  },
  computed: {
    ...mapGetters(['username'])
  },
  watch: {
    ServerRep() {
      if (this.ServerRep == 200) {
        this.$toasted.show(
          'Un lien vous a été envoyé par mail pour mettre a jour votre mots de passe !',
          this.ToastTabSucess
        );
        this.recoveryPassword = false;
      } else {
        this.$toasted.show("Le lien de modification n'a pas pu être envoyé!", this.ToastTabError);
      }
    }
  },
  mounted() {
    $(function () {
      const $menu = $('.menu');
      const $button = $('.menu-button');
      const hamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:0px;top:-1px">&#9776;</span>';
      const closeHamburgerIcon =
        '<span style="font-size:20px;color:#ffa409;position:relative;right:2px;top:-1px">&#10005;</span>';
      $button.on('click', function () {
        $menu.toggleClass('show');
        $button.text($menu.hasClass('show') ? '' : '');
        if (!$menu.hasClass('show')) {
          $button.html(hamburgerIcon);
        } else {
          $button.html(closeHamburgerIcon);
        }
      });

      // Initial state
      if (!$menu.hasClass('show')) {
        $button.html(hamburgerIcon);
      }
    });

    this.checkToken();
    this.allowWhatsapp();
    if (
      this.$store.state.apikey != '' &&
      this.$store.state.apikey != null &&
      this.$store.state.paraphrase != '' &&
      this.$store.state.paraphrase != null
    ) {
      $('#select_menu')
        .focus(function () {
          $('option').each(function () {
            $(this).html($(this).data('display'));
          });
        })
        .on('change', function () {
          $('option').each(function () {
            $(this).html($(this).val());
          });
          $(this).blur();
        });

      if (sessionStorage.getItem('locale')) {
        this.$i18n.locale = sessionStorage.getItem('locale');
      } else {
        sessionStorage.setItem('locale', this.$i18n.locale);
      }
      this.allowSinitre();
    } else {
      if (sessionStorage.getItem('locale')) {
        this.$i18n.locale = sessionStorage.getItem('locale');
      } else {
        sessionStorage.setItem('locale', this.$i18n.locale);
      }
      // this.selectCountry()
    }
  }
};
</script>

<style scoped>
.popup-login-title {
  background: #fff;
  color: #ffa409;
  text-align: center !important;
}

.login-btn {
  background: #fff;
  color: #ffa409;
  font-size: 15px;
  border-radius: 20px;
  text-transform: none;
  font-weight: 500;
}

.login-btn-mobile {
  background: rgba(255, 255, 255, 0);
  color: grey;
}

.login-btn-mobile-connect {
  background: rgba(255, 255, 255, 0);
  color: #ffa409;
}

.toOpac {
  background: rgba(255, 255, 255);
  z-index: 1000;
  border-radius: 8px;
}

.toOpac:hover {
  background: white;
}

.link-a {
  color: black;
  /*z-index: 9999;*/
}

.to-grey {
  color: #585858;
  text-transform: none;
  font-weight: 500;
}

.text-assuraf {
  color: #ffa409;
}

#menu {
  border-bottom-left-radius: 8px;
  color: #fff;
  transition: 0.8s;
  padding: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  top: 0;
}

.tile:active {
  background: #ffa409;
  color: #fff;
}

.theme--light.v-icon {
  color: #ffa409;
}

.v-list .v-list__tile--active {
  color: #ffa409;
}

.v-list__tile__action:first-of-type .v-icon {
  color: #ffa409;
}

.to_left {
  margin-left: -10px;
}

.icon-menu {
  font-size: 25px;
}

a {
  color: inherit;
  text-decoration: none;
}

a {
  text-decoration: none;
}

ul {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

li a {
  color: black;
}

li:hover {
  color: #ffa409;
  cursor: pointer;
}

ul li ul {
  visibility: visible;
  opacity: 0;
  margin-top: -3rem;
  display: none;
}

ul li:hover > ul,
ul li ul:hover {
  visibility: visible;
  opacity: 1;
  display: flex;

  transition:
    all 0.3s ease-in-out 0s,
    visibility 0s linear 0.3s,
    z-index 0s linear 0.01s;
}

#dropdown {
  margin-left: 20%;
}

#disable {
  pointer-events: none;
}

.policeLato {
  font-family: Lato, 'Helvetica Neue', Arial, sans-serif;
}
.trigger {
  width: 170px;
}

.trigger span {
  width: 200px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #ffa409;
  color: #000000;
  display: block;
  min-width: 0px;
  height: 40px;
  /*padding: 0 18px;*/
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition:
    250ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
.trigger ul.devis li {
  top: 0;
  left: 0;
  width: 200px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
.trigger ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
.trigger ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
.trigger ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.trigger ul.devis li:hover {
  border-left: 10px solid #eee;
}
.trigger:hover span {
  /*//min-width: 220px;*/
  border-radius: 22px 22px 0 0;
  transition:
    100ms border-radius 0ms,
    100ms color 100ms,
    350ms min-width 0ms;
  color: #fff;
}

.trigger:hover ul.devis {
  transform: scaley(1);
  /*//transition: 150ms transform 350ms;*/
}
.trigger:hover ul.devis a {
  opacity: 1;
  /*//transition: 150ms opacity 700ms;*/
}

.trigger-simulation {
  width: 170px;
}

.trigger-simulation span {
  width: 200px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  background: #5b94bc;
  color: #000;
  display: block;
  min-width: 0px;
  height: 40px;
  /*padding: 0 18px;*/
  z-index: 1;
  cursor: pointer;
  border-radius: 10px;
  transition:
    250ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}

.trigger-simulation ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

.trigger-simulation ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
.trigger-simulation ul.devis li {
  top: 0;
  left: 0;
  width: 200px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
.trigger-simulation ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
.trigger-simulation ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
.trigger-simulation ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
.trigger-simulation ul.devis li:hover {
  border-left: 10px solid #eee;
}
.trigger-simulation:hover span {
  /*//min-width: 220px;*/
  border-radius: 22px 22px 0 0;
  transition:
    100ms border-radius 0ms,
    100ms color 100ms,
    350ms min-width 0ms;
  color: #fff;
}

.trigger-simulation:hover ul.devis {
  transform: scaley(1);
  /*//transition: 150ms transform 350ms;*/
}
.trigger-simulation:hover ul.devis a {
  opacity: 1;
  /*//transition: 150ms opacity 700ms;*/
}

#Assurance span {
  width: 110px;
  font-weight: 500;
  letter-spacing: 0px;
  font-size: 15px;
  position: relative;
  color: #585858;
  background: none;
  min-width: 0px;
  height: 34px;
  /*padding: 0 18px;*/
  z-index: 1;
  cursor: pointer;
  transition:
    250ms border-radius 700ms,
    700ms color 700ms,
    350ms min-width 700ms;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
}
#Assurance:hover span {
  /*//min-width: 220px;*/
  border-radius: 22px 22px 0 0;
  transition:
    100ms border-radius 0ms,
    100ms color 100ms,
    350ms min-width 0ms;
  color: #000000;
  background: #e4e4e4;
}
#Assurance ul.devis {
  position: absolute;
  list-style: none;
  margin: 0;
  padding: 0;
  background: white;
  border-radius: 0 0 22px 22px;
  font-size: 14px;
  overflow: hidden;
  transform: scaley(0);
  transform-origin: top;
  transition: 150ms transform 150ms;
}

#Assurance ul.devis a {
  opacity: 0;
  transition: 150ms opacity 0ms;
}
#Assurance ul.devis li {
  top: 0;
  left: 0;
  width: 110px;
  height: 44px;
  padding: 0 20px;
  z-index: 0;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
  border-left: 0px solid #eee;
  transition: 150ms border-left 0ms;
}
#Assurance ul.devis li:before {
  content: '';
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, #eee, #fcfcfc);
  position: absolute;
  top: 0;
  left: 0;
}
#Assurance ul.devis li:last-of-type {
  border-radius: 0 0 22px 22px;
}
#Assurance ul.devis li a {
  text-decoration: none;
  color: black;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: flex-start;
}
#Assurance ul.devis li:hover {
  border-left: 10px solid #eee;
}

#Assurance:hover ul.devis {
  transform: scaley(1);
  /*//transition: 150ms transform 350ms;*/
}
#Assurance:hover ul.devis a {
  opacity: 1;
  /*//transition: 150ms opacity 700ms;*/
}

/* 
select {
    padding-left: 6%!important;
    color: #ffa409;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
    border: none!important;
    position:absolute;
    margin-top: 15px;;
} */

select {
  background-color: white;
  border-radius: 4px;
  display: inline-block;
  font: inherit;
  line-height: 1.5em;
  padding: 3.2px 30px 3.2px 8.2px;

  margin: 0;
  -webkit-box-sizing: border-box !important;
  -moz-box-sizing: border-box !important;
  box-sizing: border-box !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
}

select.language {
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
  background-position:
    calc(120% - 22px) calc(1em + -2px),
    calc(115% - 15px) calc(1em + -2px),
    calc(100% - 1.5em) 0.2em;
  background-size:
    5px 5px,
    5px 5px,
    1px 1.5em;
  background-repeat: no-repeat !important;
}

.eazy-audio-player {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  /* width: 100px; */
  text-align: center;
  padding: 6px 15px;
  /* border: 1px solid #dedede; */
  display: block;
  background: #ffa409;
  border-radius: 50%;
  font-size: 190%;
  cursor: pointer;
}
.eazy-audio-player i {
  display: inline-block;
  color: #33475c;
  font-size: 25px;
}

.eazy-audio-player span {
  display: inline-block;
  min-width: 25px;
}

#floating_bouton {
  position: fixed;
  right: 10px;
  bottom: 100px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton :hover {
  transform: scale(1.04);
}

#floating_bouton_mobile {
  position: fixed;
  right: 2px;
  bottom: 115px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton_mobile :hover {
  transform: scale(1.04);
}

#floating_bouton_whatsapp {
  position: fixed;
  right: 10px;
  bottom: 20px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton_whatsapp :hover {
  transform: scale(1.04);
}

#floating_bouton_whatsapp_mobile {
  position: fixed;
  right: 2px;
  bottom: 30px;
  width: auto;
  transition: transform 0.2s;
  /* background-color: yellow; */
  -webkit-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  -moz-box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0);
  z-index: 1;
  margin: 0;
  padding: 0;
}
#floating_bouton_whatsapp_mobile :hover {
  transform: scale(1.04);
}

.allowMarginStyle {
  margin-top: 0px !important;
}

.cont {
  line-height: 100px;
  transition: all 0.7s;
  &.hidden {
    height: 0;
    transition: all 0.7s;
  }
}

.showAnimation {
  transition: all 0.7s;
}

.picto-item {
  position: relative; /*les .picto-item deviennent référents*/
  /* cursor: help; */
  border-radius: 50%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

/* on génère un élément :after lors du survol et du focus :*/

.picto-item:hover:after,
.picto-item:focus:after {
  content: attr(aria-label); /* on affiche aria-label */
  position: absolute;
  top: -2.4em;
  left: 50%;
  transform: translateX(-50%); /* on centre horizontalement  */
  z-index: 2; /* pour s'afficher au dessus des éléments en position relative */
  white-space: nowrap; /* on interdit le retour à la ligne*/
  padding: 5px 14px;
  background: #ffa409;
  color: #2b2b2b;
  border-radius: 4px;
  font-size: 1.2rem;
}

/* on génère un second élément en :before pour la flèche */

[aria-label]:hover:before,
[aria-label]:focus:before {
  content: '▼';
  position: absolute;
  top: -1em;
  left: 50%;
  transform: translateX(-50%); /* on centre horizontalement  */
  font-size: 20px;
  color: #ffa409;
}

/* pas de contour durant le :focus */
[aria-label]:focus {
  outline: none;
}

/* déco */

h1 {
  margin-top: 20px;
  margin-bottom: 40px;
  color: #789;
  text-align: center;
  text-shadow: 1px 1px #fff;
}
p,
.pictos {
  text-align: center;
}

.picto-item {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.2em;
  width: 1.2em;
  height: 1.2em;
  font-weight: 500;
  color: #2b2b2b;
  background: #ffa409;
  font-size: 3rem;
  text-align: center;
  text-decoration: none;
  margin-top: -20px;
}

.container {
  position: relative;
  width: max-content;
  height: max-content;
  /* margin: 40px auto; */
  /* background: #000; */
  /* padding: 20px 20px 60px; */
  border-radius: 10px;
  margin-top: 300px;
}
.container h1,
.container p {
  color: #999;
}
.container .phone {
  position: relative;
  display: flex;
  flex-direction: column;
  background: #bf2626;
  height: 100%;
}
.container .phone .screen {
  padding: 20px;
  flex: 1;
}
.button {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%);
  height: 40px;
  width: 40px;
  background-color: #222;
  border: 1px solid #555;
  border-radius: 50%;
}
.top-bar {
  /* background-color: #258096;
	 padding: 20px;*/
  text-align: right;
}
.top-bar a.menu-button {
  position: relative;
  z-index: 10;
}
.top-bar a.menu-button:link,
.top-bar a.menu-button:visited,
.top-bar a.menu-button:hover,
.top-bar a.menu-button:active {
  color: #ffa409;
  text-decoration: none;
  font-size: 14px;
}

.menu {
  z-index: 1;
}
.menu ul {
  transition: all 0.5s ease-in;
  list-style-type: none;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -80%);
}
.menu ul li {
  text-align: center;
  padding: 10px;
}
.menu ul li a {
  color: #fff;
  text-decoration: none;
}
.menu {
  transition: all 0.3s ease-in;
  position: absolute;
  background: #fff;
  top: 50px !important;
  left: 0;
  width: 100%;
  height: 100vh;
  opacity: 0;
  visibility: hidden;
}
.menu.show {
  opacity: 1;
  visibility: visible;
}
.menu.show ul {
  transform: translate(-50%, -50%);
}

.menu.hide {
  opacity: 0;
  visibility: hidden;
}
</style>
